// Frontend javascript for channel pages
import { Maps as ChannelMaps } from './channel_page/maps.jsx';

Slzr.jQuery(function($) {
  // initialize the cover photo
  if (Slzr.Meta['cover-photo-url'] && !!$('.channel-cover-photo-text').get(0)) {
    let cover_photo_url;
    try {
      BackgroundCheck.init({
        targets:    '.channel-cover-photo-text',
        images:     '.channel-cover-photo',
        threshold:  60,
        minOverlap: 1
      });
    } catch (e) {
      if (e === 'Multiple backgrounds are not supported') {
        // Ignore error
        true;
      } else if (e === 'Elements not found') {
        // ignore error, likely because header text is missing
        true;
      } else {
        console.error('BackgroundCheck init error', e);
      }
    }

    // Load the cover photo and refresh after it loads (assumes 2x if ratio > 1)
    if (window.devicePixelRatio > 1.0) { cover_photo_url = Slzr.Meta['cover-photo-url-2x']; }
    if (!cover_photo_url) { cover_photo_url = Slzr.Meta['cover-photo-url']; }

    let image = new Image;
    image.src = cover_photo_url;
    image.onload = function() {
      BackgroundCheck.refresh();
      return image = null;
    };

    // Force a refresh after entire page load, including cover photo
    $(window).on('load', () => BackgroundCheck.refresh());
  }

  return new ChannelMaps($('[data-map-component]'));
});
